// removed by extract-text-webpack-plugin
module.exports = {"container":"_3yEWu","profileActions":"TxJU9","profile":"VVy-N","searchInput":"_24e9m","notificationBubble":"_1S8oG","avatarImage":"_1Jx_s","loginButton":"aUCPp","moreButton":"_1HNfq"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/breadcrumbs-widget/breadcrumbs-widget.scss
// module id = 1633
// module chunks = 0